export default "__VITE_ASSET__CRMhppb7__"